import { Environment } from '@dice/app/types/env.type';
import { PROD_ENV_CONFIG } from '@dice/environments/prod/prod.env';
import { NgxLoggerLevel } from 'ngx-logger';

export const PROD_GREEN_ENV_CONFIG: Environment = {
  ...PROD_ENV_CONFIG,
  hostNames: ['dice-prod-green.scapp-corp.swisscom.com', 'dice-prod-blue-green.scapp-corp.swisscom.com'],
  variant: 'dice-ui-prod-green',
  enableDebugInfo: false,
  isProduction: true,
  logLevel: NgxLoggerLevel.OFF,
  logEndpoint: 'https://dice-api-gateway-prod.scapp.swisscom.com/dice-splunk-forwarder/ui/log',
};
